//react imports
import React, {useEffect, useState, useRef} from 'react'
import { useMsal,  } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useLocation, useNavigate } from 'react-router-dom';
//mui imports
import { Box, Button } from '@mui/material';

//external imports

//internal imports
import HistoricSelector from '../components/Historic/HistoricSelector';
import HistoricPresenter from '../components/Historic/HistoricPresenter';
import {useSkidsWithConfig, useSkidsWithConfigDispatch} from '../components/AvailableSkids/skidsWithConfigProvider'
import { useSkidConfig, useSkidConfigDispatch } from '../components/AvailableSkids/SkidsProvider'
import {useTracker, useTrackerDispatch} from '../components/FetchTracker/FetchTrackerProvider'
import { isPopulated, toSelectOptions } from '../components/AvailableSkids/skidsHelpers';
import { fetchAvailableSkidsWithConfig, fetchAvailableSkids, fetchAvailableSkidsWithConfigHeaders } from '../Helper/Fetch/fetch';
import {getTZoffesetFromTZ} from '../Helper/timeHelpers';


import { loginRequest, protectedResources } from "../authConfig"
//type definitions
export interface DataPoint{
    [index:string]: number;
}
interface LocationState{
    targetSkid: string
}
//component
function Historic(){
    const locationState = useLocation().state as LocationState;
    var targetSkid = locationState?.targetSkid
    if (!targetSkid){
        targetSkid = ''
    }
    const { instance, accounts, inProgress } = useMsal();
    const [data, setData] = useState<DataPoint[]>([]) 
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [skid, setSkid] = useState(targetSkid);
    const [message,setMessage] = useState('Select Skid to get Started')
    const request = {scopes: protectedResources.whoami.scopes,account: accounts[0]}
    const skidsWithConfig = useSkidsWithConfig()
    const skids = useSkidConfig()
    const SkidDispatch = useSkidConfigDispatch()
    const skidsWithConfigDispatch = useSkidsWithConfigDispatch()
    const Tracker = useTracker()
    const TrackerDispatch = useTrackerDispatch()
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (skidsWithConfig.has(skid)){
        tz = skidsWithConfig.get(skid).timezone
        if (!tz){
            tz = 'UTC'
        }
    }
    const [timezone, setTimezone] = useState(tz)
    const tzOffset = getTZoffesetFromTZ(timezone)*1000
    const oldTzOffsetref = useRef(tzOffset)
    console.log("tz:",timezone)
    console.log("tz:offset:",tzOffset)
    var startUTC = Date.now()-8*3600*1000
    var endUTC = Date.now()
    console.log("Start:",startUTC,"UTC:",new Date(startUTC).toUTCString(),"Local:",new Date(startUTC).toLocaleString())
    console.log("End:",startUTC,"UTC:",new Date(endUTC).toUTCString(),"Local:",new Date(endUTC).toLocaleString())
    var startTZ = startUTC+tzOffset
    var endTZ = endUTC+tzOffset
    console.log("Start:",startUTC,"UTC:",new Date(startTZ-tzOffset).toUTCString(),"TZ:",new Date(startTZ).toUTCString())
    console.log("End:",startUTC,"UTC:",new Date(endTZ-tzOffset).toUTCString(),"TZ:",new Date(endTZ).toUTCString())
    const [startTime, setStartTime] = useState(startTZ)
    const [endTime, setEndTime] = useState(endTZ)
    console.log("startTime:",startTime)
    console.log("endTime:",endTime)
    function handleFetchResp(resp:Promise<Response>){
        resp.then(res => res.json()).then((items:DataPoint[])=>{
            setData(items)
            setLoading(false)
        }).catch((error)=>{
            setError(error)
        })  
    }
    
   // const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
   // setAvailableTimezones(avilableTimezones.add(localTimezone))
   /* 
    useEffect(()=>{
         if(skid!=''){
            console.log("selected skid:",skid)
        const skidWithConfig = skidsWithConfig.get(skid)
        console.log("skid config:",skidWithConfig)
        const skidTZ = skidWithConfig.timezone
        console.log("defaqult timezone:",skidTZ)
        setAvailableTimezones(avilableTimezones.add(skidTZ))
        setTimezone(skidTZ)
    }
    },[skid]) */
    //Checks for refetch condition, 0 skids and no previous fetch
    useEffect(()=>{
        console.log("timezone changed to:",timezone)
        const offset = getTZoffesetFromTZ(timezone)*1000
        if (offset != oldTzOffsetref.current){
            setStartTime(startTime-oldTzOffsetref.current+offset)
            setEndTime(endTime-oldTzOffsetref.current+offset)
            oldTzOffsetref.current = offset
        }
    },[timezone])
    /* console.log('Avilable skids:',skids)
    console.log('Skids fetched tracker:',Tracker.skid)
            if (isPopulated(skids)=== false && Tracker.skid === false){ 
                console.log('No Skids Available, and no previous fetch, starting refetch')
                if (inProgress ===InteractionStatus.None ){
                    fetchAvailableSkids(request, instance).then((res => res.json())).then((items)=>{
                        SkidDispatch({type:'addSkids',skids:items.skids}) 
                    })
                    TrackerDispatch({type:'skid',value:true})
                }    
            } */
        console.log('Available skids with config:',skidsWithConfig)
        console.log('Skids with config fetched tracker:',Tracker.skidsWithConfig)
        if(isPopulated(skidsWithConfig)===false && Tracker.skidsWithConfig===false){
            console.log('No Skids Available with config, and no previous fetch, starting refetch')
            if (inProgress ===InteractionStatus.None ){
                fetchAvailableSkidsWithConfigHeaders(request, instance).
                then((res => res.json()))
                .then((items)=>{
                  
                    console.log("dispatching:",items)
                    skidsWithConfigDispatch({type:'addSkidsWithConfig',skids:items})
                    
                })
                TrackerDispatch({type:'skidsWithConfig',value:true})
                //fetch here
                
                //dispatch tracker here
                //dispatch skids here
            }
    
        }

    return(
        <Box className='View-Box'>
           <HistoricSelector 
            setLoading={setLoading} 
            dataHandler={handleFetchResp} 
            setSkid={setSkid} skid={skid} 
            start={startTime} setStart={setStartTime}
            end={endTime} setEnd={setEndTime}
            timezone={timezone} setTimezone={setTimezone}
            setMessage={setMessage} 
            skids={skids}
            skidsWithConfig={skidsWithConfig}/>
           <HistoricPresenter data ={data} error={error} loading = {loading} skid={skid} start={startTime-tzOffset} end={endTime-tzOffset} message={message} timezone={timezone}/>
        </Box>
        
    )
};

export default Historic